var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aha-antd-button',{directives:[{name:"aha-emit-action",rawName:"v-aha-emit-action"}],staticClass:"present-button",attrs:{"name":"presentation-table-present","submitting":_vm.isCheckingPerm,"is-loading-inline":"","size":"sm"},on:{"click":_vm.handlePresentNowButtonClick}},[_c('span',[_vm._v("Present")])])
}
var staticRenderFns = []

export { render, staticRenderFns }